import acc from "./account/action";
import master from "./master/action";
import table from "./table/action";
import popup from "./popup/action";
import MgtStation from "./mgt-station/action";
import MgtUser from "./mgt-user/action";
import MgtPermission from "./mgt-permission/action";
import Stations from "./stations/action";
import MgtSensorData from "./mgt-sensor-data/action";
import CompareGraphActions from "./compare-graph/action";
import MgtOrgActions from "./mgt-org/action";

const ReduxActions = {
  acc,
  master,
  table,
  popup,
  MgtStation,
  mgtUser: MgtUser,
  MgtSensorData,
  MgtPermission,
  Stations,
  compareGraph: CompareGraphActions,
  MgtOrg: MgtOrgActions,
};

export default ReduxActions;
